import { render, staticRenderFns } from "./market-list.vue?vue&type=template&id=0a1c3174&scoped=true&"
import script from "./market-list.vue?vue&type=script&lang=ts&"
export * from "./market-list.vue?vue&type=script&lang=ts&"
import style0 from "./market-list.vue?vue&type=style&index=0&id=0a1c3174&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1c3174",
  null
  
)

export default component.exports